/*
 * @Author: changcheng
 * @LastEditTime: 2023-02-03 13:30:30
 */
import { useEffect, FC, useState } from "react";
// echarts and china maps
import { Form, Divider } from "antd";
import { Card } from "./components/Card";
import { getRecipientHospitalLearnView } from "@root/common/service";
import SubjectSelect from "@root/components/selectBox/subjectSelect";
const RecipientHospital: FC = () => {
  const [cardArray, setCardArray] = useState<any[]>([]);

  async function getCityViewData(subject?: number | undefined) {
    const {
      data: {
        userDataInfo = {
          userCount: 0,
          unAuditUserCount: 0,
        },
        learnRecordInfo,
        learnCourseInfo,
      },
    } = await getRecipientHospitalLearnView({ subjectId: subject });
    const { userCount, unAuditUserCount } = userDataInfo;
    const { learnUserCount, learnRatio, watchTime, averageWatchTime } =
      learnRecordInfo;
    const { totalCourseCount } = learnCourseInfo;
    let initCardArray = [
      {
        name: "人数统计",
        subtitles: [
          {
            name: "注册总人数",
            number: userCount,
          },
          {
            name: "待审核人数",
            number: unAuditUserCount,
          },
          {
            name: "学习人数",
            number: learnUserCount,
          },
        ],
      },
      {
        name: "课程统计",
        subtitles: [
          {
            name: "课程总数",
            number: totalCourseCount,
          },
        ],
      },
      {
        name: "学习统计",
        subtitles: [
          {
            name: "培训率",
            number: `${learnRatio}%`,
          },
          {
            name: "学习时长(小时)",
            number: watchTime,
          },
          {
            name: "平均学习时长(小时)",
            number: averageWatchTime,
          },
        ],
      },
    ];
    setCardArray([...initCardArray]);
  }
  useEffect(() => {
    getCityViewData();
  }, []);

  const onSelectChangeHandle = (value: any) => {
    if (value === "all") {
      value = undefined;
    }

    getCityViewData(value);
  };

  return (
    <div className="summarize">
      <div className="summarize-wrapper">
        <Form>
          <SubjectSelect
            label={false}
            showAll={true}
            styles={{ width: 160 }}
            onSelect={(value) => {
              onSelectChangeHandle(value);
            }}
          />
        </Form>
        <Divider />
        <div className="summarize-card-wrapper">
          {cardArray.map((item, index) => {
            return (
              <Card key={index} name={item.name} subtitle={item.subtitles} />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RecipientHospital;
